import axios from 'axios'
import config from '../../config/index.js'

const HTTP = axios.create({
  baseURL: config.baseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTP.interceptors.request.use(function (config) {
  if (config && config.baseURL.includes('fhabian')) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('jwt')
    return config
  }
}, function (error) {
  return Promise.reject(error)
})

export default {
  /* GET */
  _get (_url) {
    return HTTP.get(_url)
  },
  getBlob (_url) {
    return HTTP.get(_url, { responseType: 'blob' })
  },
  /* PUT */
  putIndexPatient (_url, _indexPatient) {
    return HTTP.put(_url, {
      'indexPatient': {
        indexPatientId: _indexPatient.indexPatientId,
        ssn: _indexPatient.ssn,
        firstName: _indexPatient.firstName,
        lastName: _indexPatient.lastName,
        emailAddress: _indexPatient.emailAddress,
        phoneNumber: _indexPatient.phoneNumber,
        diagnosisDate: _indexPatient.diagnosisDate,
        diagnosisLocation: _indexPatient.diagnosisLocation,
        mutation: _indexPatient.mutation,
        mutationLong: _indexPatient.mutationLong,
        highestLDL: _indexPatient.highestLDL,
        highestDLCN: _indexPatient.highestDLCN,
        screening: _indexPatient.screening,
        clinicianId: _indexPatient.clinicianId,
        indexPatientType: _indexPatient.idxPatientType
      }
    })
  },
  putCardioPatient (_url, _cardioPatient) {
    return HTTP.put(_url, {
      'personalData': {
        personId: _cardioPatient.personId,
        ssn: _cardioPatient.ssn,
        firstName: _cardioPatient.firstName,
        lastName: _cardioPatient.lastName,
        email: _cardioPatient.email,
        phoneNumber: _cardioPatient.phoneNumber,
        originalClinic: _cardioPatient.originalClinic
      }
    })
  },
  putBloodTest (_url, _bloodTest) {
    return HTTP.put(_url, {
      'bloodTest': {
        testDate: _bloodTest.testDate,
        ldl: _bloodTest.ldl,
        ldlUnit: _bloodTest.ldlUnit,
        ldlReferenceInterval: _bloodTest.ldlReferenceInterval,
        hdl: _bloodTest.hdl,
        hdlUnit: _bloodTest.hdlUnit,
        hdlReferenceInterval: _bloodTest.hdlReferenceInterval,
        totalKolesterol: _bloodTest.totalKolesterol,
        totalKolesterolUnit: _bloodTest.totalKolesterolUnit,
        totalKolesterolReferenceInterval: _bloodTest.totalKolesterolReferenceInterval,
        triglycerider: _bloodTest.triglycerider,
        triglyceriderUnit: _bloodTest.triglyceriderUnit,
        triglyceriderReferenceInterval: _bloodTest.triglyceriderReferenceInterval,
        lipoProteinA: _bloodTest.lipoProteinA,
        lipoProteinAUnit: _bloodTest.lipoProteinAUnit,
        lipoProteinAReferenceInterval: null,
        personId: _bloodTest.personId
      }
    })
  },
  /* POST */
  _post (_url) {
    return HTTP.post(_url)
  },
  postLogin (_url, _b64, _cb) {
    return HTTP.post(_url, {
      callbackUrl: _cb,
      base64: _b64
    })
  },
  postToken (_url, _sessionId) {
    return HTTP.post(_url, {
      sessionId: _sessionId
    })
  },
  postTokenTest (_url, _temp) {
    return HTTP.post(_url, {
      sessionID: _temp.sessionId,
      givenName: _temp.givenName,
      surname: _temp.surName,
      hsaId: _temp.hsaId,
      ssn: _temp.ssn
    })
  },
  postPopulationRegistry (_url, _ssn) {
    return HTTP.post(_url, {
      ssn: _ssn
    })
  },
  postJournalNote (_url, _journalNote) {
    return HTTP.post(_url, {
      journalText: _journalNote.journalText,
      journalTextDiagnosis: _journalNote.journalTextDiagnosis,
      personId: _journalNote.personId
    })
  },
  postBloodTest (_url, _bloodTest) {
    return HTTP.post(_url, {
      'bloodTest': {
        testDate: _bloodTest.testDate,
        ldl: _bloodTest.ldl,
        ldlUnit: _bloodTest.ldlUnit,
        ldlReferenceInterval: _bloodTest.ldlReferenceInterval,
        hdl: _bloodTest.hdl,
        hdlUnit: _bloodTest.hdlUnit,
        hdlReferenceInterval: _bloodTest.hdlReferenceInterval,
        totalKolesterol: _bloodTest.totalKolesterol,
        totalKolesterolUnit: _bloodTest.totalKolesterolUnit,
        totalKolesterolReferenceInterval: _bloodTest.totalKolesterolReferenceInterval,
        triglycerider: _bloodTest.triglycerider,
        triglyceriderUnit: _bloodTest.triglyceriderUnit,
        triglyceriderReferenceInterval: _bloodTest.triglyceriderReferenceInterval,
        lipoProteinA: _bloodTest.lipoProteinA,
        lipoProteinAUnit: _bloodTest.lipoProteinAUnit,
        lipoProteinAReferenceInterval: null,
        personId: _bloodTest.personId
      }
    })
  },
  postBloodTestAssessment (_url, _bloodTestAssessment) {
    return HTTP.post(_url, {
      'assessment': {
        personId: _bloodTestAssessment.pid,
        bloodSampleAssessmentValue: _bloodTestAssessment.btaValue,
        patientText: _bloodTestAssessment.patientText
      }
    })
  },
  postGeneticTest (_url, _geneticTest) {
    return HTTP.post(_url, {
      'mutation': {
        mutation: _geneticTest.mutation,
        mutationLong: _geneticTest.mutationLong,
        diagnosisDate: _geneticTest.diagnosisDate,
        diagnosisLocation: _geneticTest.diagnosisLocation,
        geneticTestAssessment: _geneticTest.geneticTestAssessment,
        personId: _geneticTest.personId
      }
    })
  },
  postHealthCenterReferral (_url, _personId, _labId, _healthCenter) {
    return HTTP.post(_url, {
      personId: _personId,
      labId: _labId,
      healthCenter: _healthCenter
    })
  },
  postFhDiagnosis (_url, _fhDiagnosis) {
    return HTTP.post(_url, {
      'fhDiagnosis': {
        personId: _fhDiagnosis.pid,
        fhDiagnosisValue: _fhDiagnosis.fhValue,
        patientText: _fhDiagnosis.patientText,
        clinicianId: _fhDiagnosis.clinicianId
      }
    })
  },
  postIndexPatient (_url, _indexPatient) {
    return HTTP.post(_url, {
      'indexPatient': {
        firstName: _indexPatient.firstname,
        lastName: _indexPatient.lastname,
        ssn: _indexPatient.ssn,
        mutation: _indexPatient.mutation,
        mutationLong: _indexPatient.mutationlong,
        diagnosisDate: _indexPatient.diagnosisdate,
        diagnosisLocation: _indexPatient.diagnosislocation,
        highestLDL: _indexPatient.highestLDL,
        highestDLCN: _indexPatient.highestDLCN,
        screening: _indexPatient.screening,
        emailAddress: _indexPatient.email,
        phoneNumber: _indexPatient.phonenumber,
        clinicianId: _indexPatient.clinicianid,
        indexPatientType: _indexPatient.idxPatientType
      }
    })
  },
  postChildrenUnder13AllChildrenRegistered (_url, _personId, _allChildrenRegistered) {
    return HTTP.post(_url, {
      personId: _personId,
      allChildrenRegistered: _allChildrenRegistered
    })
  },
  postChildrenUnder13PersonalData (_url, _personalData) {
    return HTTP.post(_url, {
      'personalData': {
        ssn: _personalData.ssn,
        firstName: _personalData.firstname,
        lastName: _personalData.lastname,
        secondaryCaregiverEmail: _personalData.email,
        secondaryCaregiverPhoneNumber: _personalData.phonenumber,
        secondaryCaregiverId: _personalData.secondarycaregiverId,
        familyTreeNode: _personalData.familytreenode,
        indexPatientId: _personalData.id,
        isSoleCustodian: _personalData.solocaregiver
      }
    })
  },
  postChildrenUnder13ScreeningAnswers (_url, _screeningAnswers) {
    return HTTP.post(_url, {
      'screeningAnswers': _screeningAnswers
    })
  },
  postCardioPatientScreeningAnswers (_url, _scrAnswrs) {
    return HTTP.post(_url, {
      'screeningAnswers': _scrAnswrs
    })
  },
  postCardioPatientPersonalData (_url, _pData) {
    return HTTP.post(_url, {
      'personalData': {
        ssn: _pData.ssn,
        firstName: _pData.firstname,
        lastName: _pData.lastname,
        email: _pData.email,
        phoneNumber: _pData.phonenumber,
        originalClinic: _pData.originalclinic
      }
    })
  },
  postCardioPatientReferralStatus (_url, _referralStatus) {
    return HTTP.post(_url, {
      'referralStatus': {
        statusType: _referralStatus.statusType,
        status: _referralStatus.status,
        personId: _referralStatus.personId
      }
    })
  },
  postCardioPatientGeneticTestDecision (_url, _genTestDecision) {
    return HTTP.post(_url, {
      'geneticTestDecision': {
        geneticTestDecision: _genTestDecision.geneticTestDecision,
        geneticTestDecisionPatientText: _genTestDecision.geneticTestDecisionPatientText,
        personId: _genTestDecision.personId
      }
    })
  },
  /* DELETE */
  _delete (_url) {
    return HTTP.delete(_url)
  },
  /* PATCH */
  _patch (_url) {
    return HTTP.patch(_url)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js